/* eslint-disable no-unused-vars */
import axios from '@/axios'
import moment from 'moment'
import equipService from '../../jsons-data/mocks/equip-service.json'

import menu_plan_list from '@/jsons-data/mocks/menu_plan_list.json'
import planDetail from '@/jsons-data/mocks/plan_details.json'
import vacancyCalendar01 from '@/jsons-data/mocks/vacancy-calendar-01.json'
import vacancyCalendar02 from '@/jsons-data/mocks/vacancy-calendar-02.json'
import orders from '@/jsons-data/mocks/orders.json'
const resource = '/v1/stay'
import plan_details_tour from '@/jsons-data/mocks/plan-detail-tour.json'
import rakutenCalendar from '@/jsons-data/mocks/rakuten_calendar.json'
import get_stay_params from '@/jsons-data/mocks/get_stay_params.json'
import get_service_detail from '@/jsons-data/mocks/get_service_detail.json'
import { forEach } from 'lodash'

export default {
  getListMenuPlans(params) {
    return new Promise((resolve, reject) => {
      axios.get('/menu/plans', { params }).then(
        (results) => {
          resolve(menu_plan_list)
        },
        () => {
          resolve(menu_plan_list)
        }
      )
    })
  },

  async searchPlan(page, size, menuNo, data = {}) {
    data.numPeople = data.numPeople || 1
    data.feeUpper = data.feeUpper || null
    data.feeLower = data.feeLower || null
    data.menuNo = menuNo || null
    data.searchSortBox = data.searchSortBox || 'PROPOSE'
    const redundant = [
      'category',
      'orderBy',
      'keyword',
      'stayNights',
      'rooms',
      'areaLrgClassCd',
      'areaMidClassCd',
      'areaSmlClassCd',
      'areaDtlClassCd'
    ]
    let params = {}
    forEach(data, (value, key) => {
      if (!redundant.includes(key)) {
        params[key] = value
      }
    })
    return new Promise((resolve, reject) => {
      axios.post(`/search/plan?page=${page}&size=${size}`, params).then(
        (response) => {
          resolve(menu_plan_list)
        },
        (error) => {
          resolve(menu_plan_list)
        }
      )
    })
  },

  async getPlanDetail(menuNo, planId, roomId, queryParams = {}) {
    // eslint-disable-next-line no-sparse-arrays
    const supportQueryParams = [
      'priceDiv',
      'crmFlag',
      'loginFlag',
      'roomCnt',
      'adultHeadCnt',
      'exUpperGradesHeadCnt',
      'exLowerGradesHeadCnt',
      'youjiAHeadCnt',
      'youjiBHeadCnt',
      'youjiCHeadCnt',
      'youjiDHeadCnt',
      'designatedMo',
      'checkInDay',
      'checkOutDay'
    ]
    const params = {}
    Object.keys(queryParams).forEach((key) => {
      if (
        supportQueryParams.includes(key) &&
        queryParams[key] !== undefined &&
        queryParams[key] !== null
      ) {
        params[key] = queryParams[key]
      }
    })
    // ${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}
    const data = {...planDetail}
    data.status = 200;
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(data)
      }, 1500)
    })
  },

  async getPlanDetailTour(menuNo, planId, roomId) {
    return new Promise((resolve, reject) => {
      // api/menus/1/plans/1/rooms/1?companyCd=1
      axios
        .get(`${resource}/menus/${menuNo}/plans/${planId}/tour`, { loading: false })
        .then(
          (response) => {
            resolve(plan_details_tour)
          },
          (error) => {
            resolve(plan_details_tour)
          }
        )
    })
  },
  async getDPPlanDetail(menuNo, planId, roomId) {
    return new Promise((resolve, reject) => {
      // api/menus/1/plans/1/rooms/1?companyCd=1
      axios
        .get(`${resource}/dp/menus/${menuNo}/plans/${planId}`, { loading: false })
        .then(
          (response) => {
            resolve(plan_details_tour)
          },
          (error) => {
            resolve(plan_details_tour)
          }
        )
    })
  },

  async getPlanIcons({ menuNo, planId }) {
    return new Promise((resolve, reject) => {
      axios.get(`/menus/${menuNo}/plans/${planId}/icons`).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          resolve([
            {
              iconCd: 'benepo_tsukaeru',
              iconNm: 'ベネポ使える',
              iconSuppl: null
            },
            {
              iconCd: 'benepo_tamaru',
              iconNm: 'ベネポ貯まる',
              iconSuppl: 'ベネポ1%付与 （１名１室利用：1%)'
            }
          ])
        }
      )
    })
  },

  async getVacancyCalendar({ menuNo, planId, roomId, queryParams = {} }) {
    const defaultParams = {
      companyCd: null,
      checkInDay: null,
      checkOutDay: null,
      roomCnt: null,
      adultHeadCnt: null,
      exUpperGradesHeadCnt: '0',
      exLowerGradesHeadCnt: '0',
      youjiAHeadCnt: '0',
      youjiBHeadCnt: '0',
      youjiCHeadCnt: '0',
      youjiDHeadCnt: '0'
    }
    return new Promise((resolve, reject) => {
      if (moment(queryParams.checkInDay).month() + 1 === 7) {
        resolve(vacancyCalendar01)
      } else {
        resolve(vacancyCalendar02)
      }
    })
  },

  async sendMailToAddress(data) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/menu/share`, data).then(
        (res) => {
          resolve(res.data)
        },
        (error) => {
          reject(error?.error)
        }
      )
    })
  },

  async putPay(params) {
    const data = {
      payMethodDiv: '10',
      menuNm: params.menuNm,
      billingAmount: params.billingAmount
    }
    return new Promise((resolve, reject) => {
      axios.put('order/select_pay', data).then(
        (res) => {
          resolve(orders)
        },
        (error) => {
          resolve(orders)
        }
      )
    })
  },

  // async putPay(params) {
  //   // const payMethodDiv = params.payMethodDiv
  //   const menuNm = params.menuNm
  //   const billingAmount = params.billingAmount
  //   return new Promise((resolve, reject) => {
  //     axios.put(`/order/select_pay?menuNm=${menuNm}&billingAmount=${billingAmount}`).then(
  //       (res) => {
  //         resolve(orders)
  //       },
  //       (error) => {
  //         resolve(orders)
  //       }
  //     )
  //   })
  // },

  async getGrantedBenepoStay({ menuNo, planId, billingAmount }) {
    return new Promise((resolve, reject) => {
      // axios
      //   .get(
      //     `/menu/${menuNo}/plans/${planId}/amount/${billingAmount}/granted-benepo-stay`,
      //     { loading: false }
      //   )
      //   .then(
      //     (res) => {
      //       // resolve(res?.data)
      //       resolve({
      //         //for mock test
      //         grantedBenepo: billingAmount * 2
      //       })
      //     },
      //     (error) => {
      //       resolve({
      //         //for mock test
      //         grantedBenepo: billingAmount * 2
      //       })
      //     }
      //   )
      resolve({ "grantedBenepo": 234 });
    })
  },
  async checkRoomLimit(params) {
    return new Promise((resolve, reject) => {
      axios.post(`${resource}/order/limit-check-stay`, params).then(
        (response) => {
          const data = {
            status: 200
          }
          resolve(data.status)
        },
        (error) => {
          const data = {
            status: 200
          }
          resolve(data.status)
        }
      )
    })
  },
  async getStayParams({ menuNo, planId, roomId, params }) {
    return new Promise((resolve, reject) => {
      // axios
      // .get(`${resource}/menu/${menuNo}/plans/${planId}/rooms/${roomId}/stay-param`, {
      //   params
      // })
      // .then(() => {
      //   resolve({
      //     payMthdInfo: {
      //       benepoUseFlag: '1'
      //     }
      //   })
      // })
      // .catch(() => {
      //   resolve({
      //     payMthdInfo: {
      //       benepoUseFlag: '1'
      //     }
      //   })
      // })
      resolve(get_stay_params)
    })
  },
  async getServiceDetail(menuNo) {
    return new Promise((resolve, reject) => {
      // axios.get(`${resource}/menu/${menuNo}/equipments-services`).then(
      //   (response) => {
      //     resolve(equipService)
      //     resolve(response.data)
      //   },
      //   (error) => {
      //     resolve(equipService)
      //     reject(error.data)
      //   }
      // )
      resolve(get_service_detail);
    })
  },
  async getRakutenVacancy(params) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: rakutenCalendar
        })
      }, 1000)
    })
  }
}
